/* global globalThis */
import { appInsights } from "../AppInsights";
import { UAParser } from "ua-parser-js";

const queryHeaderFooter = async (endpoint = "", responseType) => {
  try {
    const result = await fetch(
      `${process.env.REACT_APP_HEADERFOOTER_ENDPOINT}${endpoint}`,
      {
        headers: {
          accepts: responseType,
          "Access-Control-Max-Age": 86400,
          "Ocp-Apim-Subscription-Key": process.env.REACT_APP_HEADERFOOTER_APIM_KEY
        }
      }
    ).then(response => {
      if (!response.ok) throw new Error(`${endpoint} fetch failed.`);
      return responseType === "application/json"
        ? response.json()
        : response.text();
    });
    return result;
  } catch (error) {
    appInsights?.trackException({ exception: `${error} Failed to retrieve headerFooter.` });
    return { error };
  }
};

const logError = error => {
  return false;
};
const AppUserAgents = {
  Android: "ALKApp/Android",
  iOS: "ALKApp/iOS",
  Header: "NativeHeader"
};

/**
 * Detects if the request is from a mobile device / native app webview.
 * Uses ua-parser-js device.type check + ALKApp custom UA string + generic "mobi" detection.
 */
export function isFromMobileWebView() {
  const ua = new UAParser(globalThis.navigator.userAgent);
  return (
    ua.getDevice().type === "mobile" ||
    globalThis.navigator.userAgent.includes(AppUserAgents.Android) ||
    globalThis.navigator.userAgent.includes(AppUserAgents.iOS) ||
    globalThis.navigator.userAgent.toLowerCase().includes("mobi")
  );
}

export function isNativeHeader() {
  return (
    globalThis.navigator.userAgent.includes(AppUserAgents.Header)
  );
}

/**
 * Injects script elements from an HTML string into the document body.
 * Scripts added via innerHTML don't execute; this re-creates them as live elements.
 */
const injectScripts = (html) => {
  const wrapper = document.createElement('div');
  wrapper.innerHTML = html;
  const scripts = wrapper.querySelectorAll('script');
  scripts.forEach((script) => {
    const newScript = document.createElement('script');
    if (script.src) {
      newScript.src = script.src;
    } else {
      newScript.textContent = script.textContent;
    }
    document.body.appendChild(newScript);
  });
};

/**
 * Loads Header Footer Lite for mobile webview.
 * Matches the pattern used by flightsearch-lem: detects ALKApp user-agent and
 * fetches the /header-footer-lite/mobileapps/ endpoint.
 * The response includes Tealium analytics and the guest-session bootstrap script
 * (headerLiteScripts.js) which initializes @alaskaair/guest-session for session
 * keep-alive and implicit login — no client-side initSession() call needed.
 */
const mountHeaderFooterLite = async () => {
  const htmlJson = await queryHeaderFooter(
    `header-footer-lite/mobileapps/`,
    "application/json"
  );

  if (htmlJson.error) {
    appInsights?.trackException({ exception: `Failed to load HF Lite: ${htmlJson.error}` });
    return { error: htmlJson.error };
  }

  if (htmlJson.header) {
    injectScripts(htmlJson.header);
  }

  return htmlJson;
};

const mountHeaderFooter = async (retries = 1) => {
  if (!isFromMobileWebView()) {
    const htmlJson = await queryHeaderFooter(
      `headerfooter?var=loyalty`,
      "application/json"
    );

    if (htmlJson.error) {
      if (retries > 0) return mountHeaderFooter(retries - 1);
      return logError(htmlJson.error);
    }

    if (htmlJson.header) {
      injectScripts(htmlJson.header);
    }

    return htmlJson;
  }

  // Mobile webview: load HF Lite for session management and implicit login
  return mountHeaderFooterLite();
};

export { mountHeaderFooter, mountHeaderFooterLite };